import React from "react";
import { useTranslation } from "react-i18next";

export const Select = ({
  className = "",
  label = "",
  name = "select",
  value = "",
  options = [],
  onChange = () => {},
}) => {
  const { t } = useTranslation();

  return (
    <div className={className}>
      {label && (
        <label
          htmlFor={name}
          className="mb-1 block text-sm font-medium text-gray-700"
        >
          {t(label)}
        </label>
      )}
      <select
        id={name}
        name={name}
        className="block w-full pl-3 pr-10 py-2 text-sm border-gray-300 focus:border-gray-300 focus:outline-none focus:ring-transparent rounded-md"
        value={value}
        onChange={onChange}
      >
        {options.map((option) => (
          <option key={option.value} value={option.value}>
            {t(option.label)}
          </option>
        ))}
      </select>
    </div>
  );
};
